// Step4.js - Carparking Issues (Enhanced with defaultDateTime support and corrected dropdown values)
import ModernDataTable from '../ui/ModernDataTable';

const Step4 = ({ carparkItems, setCarparkItems, defaultDateTime, enablePhotoUpload, referenceNo, sectionName, dataTableRef }) => {
      const carparkFields = [
            {
                  name: 'timeRaised',
                  type: 'datetime',
                  label: 'Time Raised',
                  header: 'Time Raised',
                  required: true,
                  validationMessage: 'Please enter when the carpark issue was first reported',
                  hint: 'Record the exact time when the carpark issue was discovered or first reported to staff.'
            },
            {
                  name: 'description',
                  type: 'textarea',
                  label: 'Description of Issue',
                  header: 'Description of Issue',
                  placeholder: 'Describe the carpark issue including specific location details, nature of the problem (blocked access, equipment failure, safety hazard), number of vehicles affected, impact on traffic flow, and any safety concerns or immediate risks',
                  required: true,
                  validationMessage: 'Please provide a detailed description of the carpark issue',
                  hint: (
                        <div>
                              <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Describe the carpark issue including:</p>
                              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                    <li>Specific location within the carpark (level, section, bay number)</li>
                                    <li>Nature of the problem (blocked access, equipment failure, safety hazard, etc.)</li>
                                    <li>Number of vehicles or patrons affected</li>
                                    <li>Impact on traffic flow or access</li>
                                    <li>Any safety concerns or immediate risks</li>
                              </ul>
                        </div>
                  )
            },
            {
                  name: 'location',
                  type: 'text',
                  label: 'Specific Location in Carpark',
                  header: 'Location',
                  placeholder: 'e.g. Level 2 Section B, Exit Gate 3, Bay 45-50, Ground Floor Entry Ramp',
                  required: true,
                  validationMessage: 'Please specify the exact location within the carpark',
                  hint: 'Be as specific as possible - include level, section, bay numbers, or landmarks to help others locate the issue quickly.'
            },
            {
                  name: 'vehiclesAffected',
                  type: 'number',
                  label: 'Number of Vehicles Affected (if applicable)',
                  header: 'Vehicles Affected',
                  placeholder: 'Enter number of vehicles impacted by this issue',
                  min: 0,
                  max: 999,
                  validationMessage: 'Please enter a valid number of affected vehicles (0-999)',
                  hint: 'Enter the approximate number of vehicles that were directly impacted by this carpark issue. Enter 0 if no vehicles were affected.',
                  displayTransform: (value) => value > 0 ? `${value} vehicles` : 'None'
            },
            {
                  name: 'actionsTaken',
                  type: 'textarea',
                  label: 'Actions Taken',
                  header: 'Actions Taken',
                  placeholder: 'Describe actions taken to resolve the issue including immediate safety measures, traffic management or redirection, maintenance staff contacted, equipment repairs, patron assistance provided, alternative arrangements made, and escalation details',
                  validationMessage: 'Please describe the actions taken to address the carpark issue',
                  hint: (
                        <div>
                              <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document all actions taken including:</p>
                              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                    <li>Immediate safety measures implemented</li>
                                    <li>Traffic management or redirection</li>
                                    <li>Maintenance or technical staff contacted</li>
                                    <li>Equipment repairs or replacements</li>
                                    <li>Patron assistance provided</li>
                                    <li>Alternative arrangements made</li>
                                    <li>Full name of escalation point (if escalated)</li>
                              </ul>
                        </div>
                  )
            }
      ];

      return (
            <ModernDataTable
                  suppressTitle
                  data={carparkItems}
                  setData={setCarparkItems}
                  fields={carparkFields}
                  addButtonText="Add Carpark Issue"
                  emptyMessage="No carpark issues added yet."
                  truncateLines={2}
                  defaultDateTime={defaultDateTime}
                  enablePhotoUpload={enablePhotoUpload}
                  referenceNo={referenceNo}
                  sectionName={sectionName || 'carpark'}
                  ref={dataTableRef}
            />
      );
};

export default Step4;